// extracted by mini-css-extract-plugin
export var checkbox = "_7y-0";
export var circle = "_7y-3";
export var horizontalContainer = "_7y-7";
export var sm = "_7y-5";
export var switch0 = "_7y-2";
export var switchDisabled = "_7y-8";
export var switchEnabled = "_7y-1";
export var textSwitchContainer = "_7y-9";
export var textSwitchOption = "_7y-a";
export var textSwitchOptionSelected = "_7y-b";
export var verticalContainer = "_7y-6";
export var xs = "_7y-4";